import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import { Row } from "react-bootstrap";
import SectionHeader from 'components/SectionHeader';
import PageSection from 'components/PageSection';
import BrandItem from 'components/BrandItem';

const Brands = ({className, frontmatter}) => {
  if (!frontmatter) {
    return null;
  }
  const { anchor, header: rootHeader, subheader: rootSubHeader, brands } = frontmatter;

  return (
    <PageSection className={clsx('brands-section', className)} id={anchor}>
      <Row>
        <SectionHeader header={rootHeader} subheader={rootSubHeader} />
      </Row>
      <Row>
        {brands.map(({imageFileName, header, url }) => (
          <BrandItem
            key={header}
            imageFileName={imageFileName}
            url={url}
            header={header}
          />
        ))}
      </Row>
    </PageSection>
  );
};

Brands.propTypes = {
  className: PropTypes.string,
  frontmatter: PropTypes.object,
};

Brands.defaultProps = {
  className: null,
  frontmatter: null,
};

export default Brands;